import { useState } from 'react';
import { resolveImagePath } from '@/utils/imageMap';

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const logo = resolveImagePath('/images/logo.png');

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/">
              <img 
                src={logo}
                alt="The Reno Phil"
                className="h-12 w-auto"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="/concerts" className="text-gray-700 hover:text-gray-900 font-medium">
              CONCERTS
            </a>
            <a href="/education" className="text-gray-700 hover:text-gray-900 font-medium">
              EDUCATION
            </a>
            <a href="/about" className="text-gray-700 hover:text-gray-900 font-medium">
              ABOUT
            </a>
            <a href="/support" className="text-gray-700 hover:text-gray-900 font-medium">
              SUPPORT
            </a>
            <a href="/contact" className="text-gray-700 hover:text-gray-900 font-medium">
              CONTACT
            </a>
            <a 
              href="/tickets" 
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors"
            >
              TICKETS
            </a>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-gray-900 focus:outline-none focus:text-gray-900"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t">
              <a href="/concerts" className="block px-3 py-2 text-gray-700 hover:text-gray-900 font-medium">
                CONCERTS
              </a>
              <a href="/education" className="block px-3 py-2 text-gray-700 hover:text-gray-900 font-medium">
                EDUCATION
              </a>
              <a href="/about" className="block px-3 py-2 text-gray-700 hover:text-gray-900 font-medium">
                ABOUT
              </a>
              <a href="/support" className="block px-3 py-2 text-gray-700 hover:text-gray-900 font-medium">
                SUPPORT
              </a>
              <a href="/contact" className="block px-3 py-2 text-gray-700 hover:text-gray-900 font-medium">
                CONTACT
              </a>
              <a 
                href="/tickets" 
                className="block mx-3 mt-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors text-center"
              >
                TICKETS
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}